import axios from "axios";

const headers = (token) => ({
  "Content-Type": "application/json ",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const buildQuery = (params = {}) => {
  const query = Object.keys(params)
    .filter((key) => params[key] !== "" && params[key] !== null && params[key] !== undefined)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");

  return query ? `?${query}` : "";
};

export const getClaimRiskRetentionProfiles = (token, params = {}) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention" +
        buildQuery(params),
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskRetentionAnalytics = (token, params = {}) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention/analytics" +
        buildQuery(params),
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskRetentionProfile = (token, leadId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE + "/claim-risk-retention/" + leadId,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskRetentionFallbackOrders = (token, leadId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/orders" +
        buildQuery({
          lead_id: leadId,
          multiple_status: "4,8",
          records_per_page: 20,
        }),
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskRetentionFallbackClaims = (token, leadId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim" +
        buildQuery({
          lead_id: leadId,
          page_size: 20,
        }),
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const downloadClaimRiskRetentionExport = (token, params = {}) => {
  return axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE +
      "/claim-risk-retention/export" +
      buildQuery(params),
    {
      headers: headers(token),
      responseType: "blob",
    },
  );
};

export const startClaimRiskRetentionRefresh = (token, body = {}) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/claim-risk-retention/refresh",
      body,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const previewClaimRiskCampaign = (token, body = {}) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/claim-risk-retention/campaign/preview",
      body,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const sendClaimRiskCampaign = (token, body = {}) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/claim-risk-retention/campaign/send",
      body,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskCampaignStatus = (token, campaignId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention/campaign/" +
        campaignId,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskCampaigns = (token, params = {}) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention/campaigns" +
        buildQuery(params),
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskCampaignDetails = (token, campaignId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention/campaigns/" +
        campaignId,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};

export const getClaimRiskRetentionRefreshRun = (token, runId) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/claim-risk-retention/refresh/" +
        runId,
      { headers: headers(token) },
    )
    .then((res) => res.data);
};
